import gql from 'graphql-tag';

export const ASSOCIAR_LINK_AFILIADO = gql`
  mutation associarLinkAfiliado($linkAfiliadoId: String!) {
    associarLinkAfiliado(linkAfiliadoId: $linkAfiliadoId) {
      id
    }
  }
`;
